<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/liedeIndex">首页</el-menu-item>
        <el-menu-item index="/liede/currentDataTable?bridgeId=09bbc800-31db-43c4-aa1c-5b941fae5641">实时数据表</el-menu-item>
        <el-submenu :index="'/liede/dataHistory?bridgeId=09bbc800-31db-43c4-aa1c-5b941fae5641&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/liede/dataHistory?bridgeId=09bbc800-31db-43c4-aa1c-5b941fae5641&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/liede/dataHistory?bridgeId=09bbc800-31db-43c4-aa1c-5b941fae5641"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="GUANGZHOU" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main lie-de">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "liede",
  data() {
    return {
      bridgeId: "09bbc800-31db-43c4-aa1c-5b941fae5641",
      envInfo: {
        envId: "a057ce8e-4cf3-4b3f-bb4e-d20007e2d2df",
        weather: "7e35a328-a57f-48b0-903d-5362704a16d3",
        humidity: "acb9e89c-6d83-43a4-98e8-0789115c476b",
        temperature: "24cf5b5f-c3ff-473b-9124-85af967db3e4",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>